import React from 'react';
import { MarketData } from '../../types';
import MarketInfo from './MarketInfo';

interface OfficeInfoProps {
  selectedMarket: MarketData;
  closePopoutButton: React.ReactElement;
}

const OfficeInfo = ({ selectedMarket, closePopoutButton }: OfficeInfoProps) => {
  return (
    <MarketInfo
      selectedMarket={selectedMarket}
      closePopoutButton={closePopoutButton}
    />
  );
};

export default OfficeInfo;
